import { Stack } from '@mui/material';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useFeatureFlag } from '../../../contexts/FeatureFlagContext';
import { QuestCalendarSkeleton } from './QuestCalendarSkeleton';
import { QuestDaySkeleton } from './QuestDaySkeleton';
import { QuestHeaderSkeleton } from './QuestHeaderSkeleton';
import { TodayQuestProgressSkeleton } from './TodayQuestProgressSkeleton';

export type QuestListSkeletonProps = {
    selectedDate: dayjs.Dayjs;
};

export const QuestListSkeleton: FC<QuestListSkeletonProps> = ({ selectedDate }) => {
    const isToday = selectedDate.isSame(dayjs(), 'day');
    const goalsEnabled = useFeatureFlag('goals');

    return (
        <Stack
            height="100%"
            paddingTop="calc(var(--tg-viewport-content-safe-area-inset-top, 0px) + var(--tg-viewport-safe-area-inset-top, 0px))"
        >
            <QuestCalendarSkeleton isToday={isToday} />
            <QuestHeaderSkeleton />
            {isToday && goalsEnabled && <TodayQuestProgressSkeleton />}
            <QuestDaySkeleton />
        </Stack>
    );
};
